import React, { memo, useRef, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import InputBase from '@material-ui/core/InputBase'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import InputAdornment from '@material-ui/core/InputAdornment'

const useInputStyles = makeStyles(() => {
  return {
    root: {
      height: 'inherit',
      width: 'inherit',
      borderRadius: '6px',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: ({ active }) =>
        active ? '#4AA652' : 'rgba(21, 31, 49, 0.15)',
      backgroundColor: '#ffffff',
      //boxShadow: '0px 8px 14px rgba(0, 0, 0, 0.1)',
      cursor: 'pointer !important',
      transition: '0.3s',
      '&:hover': {
        borderColor: '#4AA652',
        transition: '0.3s',
      },
    },
    disabled: {
      color: '#151F31',
    },
    input: {
      width: '100%',
      height: '100%',
      fontSize: 14,
      letterSpacing: '0.016em',
      padding: '0 0 0 16px',
      color: '#151F31',
      cursor: 'pointer !important',
      textOverflow: 'ellipsis',
    },
  }
})

const DropDownButton = (props) => {
  const { active = false, withSearch = false, ...rest } = props

  const inputRef = useRef()

  const classes = useInputStyles({ active })

  const activeClassName = active ? 'active' : ''

  useEffect(() => {
    if (active && withSearch) {
      inputRef.current.focus()
    } else {
      inputRef.current.blur()
    }
  }, [active, withSearch])

  return (
    <InputBase
      className="dropdown_button_conrol"
      classes={classes}
      endAdornment={
        <InputAdornment position="start">
          <ExpandLessIcon className={`expand_icon ${activeClassName}`} />
        </InputAdornment>
      }
      {...rest}
      readOnly={!withSearch}
      inputRef={inputRef}
    />
  )
}

export default memo(DropDownButton)
